import Vue from 'vue';
import Router from 'vue-router';
import SiteRoutes from '@/router/routes/site-routes';
import defaultRoutes from '@/router/routes/default-routes';
import { AppLanguages } from '@/utils/handlers/app-language-handler';

Vue.use(Router);

export default new Router({

  base: process.env.BASE_URL,

  mode: 'history',

  routes: [
    ...new SiteRoutes(AppLanguages.FR).routes,
    ...new SiteRoutes(AppLanguages.EN).routes,
    ...defaultRoutes,
  ],

});
